import {
  NewCashDrawerTotalsDTO,
  UpdateCashDrawerTotalsDTO,
} from "@/api/dto/CashDrawerTotalsDTO";

export interface ICashDrawerTotals {
  totalId: number;
  reportDate: string; // ISO date string
  cashDrawerId?: string;
  startingCashTotalCents: number;
  endingCashTotalCents?: number;
  cashSalesCents?: number;
  endingCheckTotalCents?: number;
  checkSalesCents?: number;
  finalizedFlag: string; // single character string
  finalizedOn?: string; // ISO date-time string
  finalizedBy?: string;
}

export class CashDrawerTotals implements ICashDrawerTotals {
  totalId: number;
  reportDate: string; // ISO date string
  cashDrawerId?: string;
  startingCashTotalCents: number;
  endingCashTotalCents?: number;
  cashSalesCents?: number;
  endingCheckTotalCents?: number;
  checkSalesCents?: number;
  finalizedFlag: string; // single character string
  finalizedOn?: string; // ISO date-time string
  finalizedBy?: string;

  constructor(config: ICashDrawerTotals) {
    this.totalId = config.totalId;
    this.reportDate = config.reportDate;
    this.cashDrawerId = config.cashDrawerId;
    this.startingCashTotalCents = config.startingCashTotalCents;
    this.endingCashTotalCents = config.endingCashTotalCents;
    this.cashSalesCents = config.cashSalesCents;
    this.endingCheckTotalCents = config.endingCheckTotalCents;
    this.checkSalesCents = config.checkSalesCents;
    this.finalizedFlag = config.finalizedFlag;
    this.finalizedOn = config.finalizedOn;
    this.finalizedBy = config.finalizedBy;
  }

  get updateRequestBody(): UpdateCashDrawerTotalsDTO {
    return {
      reportDate: this.reportDate,
      cashDrawerId: this.cashDrawerId,
      startingCashTotalCents: this.startingCashTotalCents,
      endingCashTotalCents: this.endingCashTotalCents,
      cashSalesCents: this.cashSalesCents,
      endingCheckTotalCents: this.endingCheckTotalCents,
      checkSalesCents: this.checkSalesCents,
      finalizedFlag: this.finalizedFlag,
      finalizedOn: this.finalizedOn,
      finalizedBy: this.finalizedBy,
    };
  }

  get createRequestBody(): NewCashDrawerTotalsDTO {
    return {
      reportDate: this.reportDate,
      cashDrawerId: this.cashDrawerId,
      startingCashTotalCents: this.startingCashTotalCents,
      endingCashTotalCents: this.endingCashTotalCents,
      cashSalesCents: this.cashSalesCents,
      endingCheckTotalCents: this.endingCheckTotalCents,
      checkSalesCents: this.checkSalesCents,
      finalizedFlag: this.finalizedFlag,
      finalizedOn: this.finalizedOn,
      finalizedBy: this.finalizedBy,
    };
  }
}
